<template>
  <div id="navigation">
    <div class="ui inverted huge borderless fixed fluid menu">
      <a class="header item">{{ $t('studentPortal') }}</a>
    </div>
    <div class="ui grid">
      <div class="row">
        <div class="column" id="content">
          <div class="ui segment">
            <router-view />
            <div class="ui inverted dimmer" v-bind:class="{ active: loading }">
              <div class="ui loader"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Navigation',
  computed: mapGetters({
    loading: 'loading',
  }),
};
</script>

<style type="text/css">
body {
  display: relative;
}
#sidebar {
  position: fixed;
  top: 51.8px;
  right: 0;
  bottom: 0;
  width: 18%;
  background-color: #f5f5f5;
  padding: 0px;
}
#sidebar .ui.menu {
  margin: 2em 0 0;
  font-size: 16px;
}
#sidebar .ui.menu > a.item {
  color: #337ab7;
  border-radius: 0 !important;
}
#sidebar .ui.menu > a.item.active {
  background-color: #337ab7;
  color: white;
  border: none !important;
}
#sidebar .ui.menu > a.item:hover {
  background-color: #4f93ce;
  color: white;
}
#content {
  margin-left: 20px;
  margin-right: 19%;
  width: 81%;
  margin-top: 3em;
  padding-left: 3em;
  float: left;
}
#content > .ui.grid {
  padding-right: 4em;
  padding-bottom: 3em;
}
#content h1 {
  font-size: 36px;
}
#content .ui.divider:not(.hidden) {
  margin: 0;
}
#content table.ui.table {
  border: none;
}
#content table.ui.table thead th {
  border-bottom: 2px solid #eee !important;
}
.ui.segment {
  border: 0px;
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue